export const RUN_BUTTON_DEFAULTS = {
  HEIGHT: "30px",
  CTA_TEXT: "Run",
  // space between button and dropdown
  GAP_SIZE: "10px",
  DROPDOWN_HIGHLIGHT_BG: "#E7E7E7",
};
export const testLocators = {
  runJSAction: "run-js-action",
};
export const NO_FUNCTION_DROPDOWN_OPTION = {
  label: "No function available",
  value: "",
  data: null,
};
